<template>
  <!-- :modal-append-to-body="true" -->
  <el-dialog
    :close-on-click-modal="false"
    :show-close="false"
    :destroy-on-close="true"
    :append-to-body="true"
    :title="'refreshLoginModa.title'"
    v-model="loginTimedOut"
    width="300px"
    center
  >
    <div>
      <el-form
        :inline="true"
        v-loading="sending"
        :model="form"
        status-icon
        :rules="formRules"
        ref="form"
        @keypress.enter.prevent
        class="default-form"
      >
        <el-form-item
          :label="$t('authPage.formFields.password')"
          prop="password"
        >
          <el-input
            :disabled="sending"
            type="password"
            v-model="form.password"
          ></el-input>
        </el-form-item>

        <div class="m0 default-form__submit-box">
          <el-button @click="logOut">{{ $t("header.logOut") }}</el-button>
          <el-button
            :disabled="sending"
            type="primary"
            @click="submitForm('form')"
            >{{ $t("authPage.formFields.submitBtn") }}</el-button
          >
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { AXIOS_CLIENT } from "@/config/api-service-client.js";

export default {
  name: "RefreshLoginModal",
  data() {
    return {
      sending: false,

      form: {
        password: null,
      },
      formRules: {
        password: [
          {
            required: true,
            message: this.$t("authPage.formFields.password_error"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions(["getToken", "getUserInfo", "logOut"]),
    checkClose() {
      console.log("checkClose");
      this.$store.commit("mutate_login_timed_out", false);
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        try {
          if (valid) {
            this.sending = true;
            const userData = {
              client_name:
                sessionStorage.getItem("client_name") ||
                localStorage.getItem("client_name"),
              login:
                sessionStorage.getItem("login") ||
                localStorage.getItem("login"),
              password: this.form.password,
            };
            if (this.loginTimedOutAllowRefresh) {
              delete AXIOS_CLIENT.defaults.headers.common["Authorization"];
            }

            const response = await this.getToken(userData);
            await this.getUserInfo(response);
            await this.checkClose();

            if (this.loginTimedOutAllowRefresh) {
              location.reload();
            }
            this.sending = false;
          } else {
            console.log("error submit!!");
            return false;
          }
        } finally {
          this.sending = false;
        }
      });
    },
  },
  computed: {
    ...mapGetters(["loginTimedOut", "currentUser"]),
    ...mapState({
      loginTimedOutAllowRefresh: (state) =>
        state.currentUser.loginTimedOutAllowRefresh,
    }),
  },
};
</script>

<style lang="scss">
.login-refresh-modal {
  #app {
    filter: blur(4px);
  }
  .v-modal {
    // background:none;
    opacity: 0.5;
  }
}
</style>
